// SignIn.js
import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

// import AppTheme from '../shared-theme/AppTheme';
// import ColorModeSelect from '../shared-theme/ColorModeSelect';

import authenticationService from '../Utilities/authenticationService';

import { useSelector, useDispatch } from 'react-redux';

// import mui from '../Imports/muiImports';
import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';

import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Password } from 'primereact/password';

import { VERSION, DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

export default function SignIn(props) { 

  const { reset4All, setCredential, setUsernameErrorMessage, setPasswordErrorMessage, setUsername, setPassword, setInProgress, setPasswordError, setUsernameError, setSupervisorList, setManagerList, setAssignList, setServiceList, setMemberList } = reducer;
  const { FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, Search, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem, SystemConfig } = component;  
  const { postLogListItem, deleteVerseReadLogListItem, postVerseReadLogListItem, postHistoryListItem, getHasNoteVerses, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, chapter4SetVerseReadLogList, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();
  
  const navigate = useNavigate();
  
  const dispatch = useDispatch(); // dispatch(
//   const usernameErrorMessage = useSelector((state) => state.signIn.usernameErrorMessage);
//   const passwordErrorMessage = useSelector((state) => state.signIn.passwordErrorMessage);
  const username = useSelector((state) => state.signIn.username);
  const password = useSelector((state) => state.signIn.password);
  const inProgress = useSelector((state) => state.signIn.inProgress);
  const usernameErrorMessage = useSelector((state) => state.signIn.usernameErrorMessage);
//   const passwordError = useSelector((state) => state.signIn.passwordError);
//   const usernameError = useSelector((state) => state.signIn.usernameError);
//   const loading4SignIn = useSelector((state) => state.signIn.loading4SignIn);
  const credential = useSelector((state) => state.signIn.credential);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (username && password) {
      dispatch(setInProgress(true));
      authenticationService
      .signin(username, password)
      .then((token) => {
        if (token.length > 0) {
          dispatch(setUsernameError(false));
          dispatch(setPasswordError(false));
          const credential = {
            UserName: username,
            Token: token
          };
          dispatch(setCredential(credential));
          dispatch(setInProgress(false));
          navigate('/home');
        } else {
          dispatch(setUsernameError(true));
          dispatch(setPasswordError(true));
          dispatch(setUsernameErrorMessage('帳戶名稱或密碼錯誤，請重新輸入'));
          dispatch(setInProgress(false));
        }
      })
    }
  };

  const validateInputs = (e) => {
    dispatch(reset4All());
    handleSubmit(e);
  };

  const onChangeUsername = (e) => {
    dispatch(setUsername(e.target.value));
  }  

  useEffect(() => {
    //dispatch(reset4All());
  }, []);

 return (

    <div className="w-full flex justify-content-center mt-6">

      {/* --- CSS OVERRIDE FOR PRIMEREACT PASSWORD BUG --- */}
      <style>{`
        .force-full-width,
        .force-full-width .p-icon-field,
        .force-full-width .p-password-input {
            width: 100% !important;
        }
      `}</style>
      {/* ------------------------------------------------ */}

      <Card title="「服事系統」登入帳戶"
        style={{ 
            width: '100%',       
            maxWidth: '10%',    
            minWidth: '320px'   
        }}            
      >

        <div className="flex flex-column gap-3">

            <label htmlFor="username">帳戶名稱</label>
            <InputText 
                id="username" 
                value={username} 
                onChange={onChangeUsername} 
                className="w-full"
            />      

            <label htmlFor="password">密碼</label>
            <Password 
                id="password" 
                value={password} 
                onChange={e => dispatch(setPassword(e.target.value))} 
                toggleMask               
                feedback={false}         
                className="force-full-width" // <-- Attach the custom override class here
            />                       

            <Button
              type="submit"
              onClick={validateInputs}
              style={{ width: '100%', justifyContent: 'center' }}
            >
              登入
            </Button>

            {usernameErrorMessage && (
              <div className="p-error text-center" style={{ textAlign: 'center' }}>
                {usernameErrorMessage}
              </div>
            )}

        </div>     

        <p className="text-right text-xs text-color-secondary m-3">
          {VERSION}
        </p>

      </Card>

      {inProgress && (
          <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              backgroundColor: 'rgba(0, 0, 0, 0.3)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999 
          }}>
              <ProgressSpinner style={{width: '250px', height: '250px'}} strokeWidth="1" />
          </div>
      )}      

    </div>

  );

}